module.exports = __webpack_public_path__ + "img/ic-soon.2695762f.svg";